(function () {
  'use strict';
  window.Brume = window.Brume || {};

  /**
   * Help Widget
   * Floating chat bubble → branching menu. Leaves are either the contact
   * channels (Email / Instagram / WhatsApp) or a "leave your details" form
   * (Shopify native contact form). Works on desktop and mobile.
   */
  function initHelpWidget() {
    var widget = document.getElementById('helpWidget');
    if (!widget) return;

    var fab = document.getElementById('helpFab');
    var panel = document.getElementById('helpPanel');
    var body = panel.querySelector('.help-panel-body');
    var titleEl = document.getElementById('helpTitle');
    var backBtn = document.getElementById('helpBack');
    var closeBtn = document.getElementById('helpClose');
    var steps = panel.querySelectorAll('.help-step');
    var issueInput = document.getElementById('helpIssue');
    var formNote = document.getElementById('helpFormNote');

    var history = [];
    var current = 'root';

    /* Visible only while the visitor is past 60% of the page's scrollable
       distance; scrolling back above the mark hides it again. It starts
       hidden (is-awaiting-scroll, set in the snippet) so it never flashes on
       load. While the panel is open it stays put, so it never disappears
       mid-conversation; the rule applies again on close. A page too short
       to scroll shows it once loaded: measuring at DOMContentLoaded would
       call a page whose images have not given it height yet "short". */
    var REVEAL_AT = 0.6;
    var revealTicking = false;
    var pageLoaded = document.readyState === 'complete';

    function setScrollHidden(hidden) {
      widget.classList.toggle('is-awaiting-scroll', hidden);
    }

    function checkReveal() {
      revealTicking = false;
      if (widget.classList.contains('is-open')) return;
      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) {
        if (pageLoaded) setScrollHidden(false);
        return;
      }
      setScrollHidden(window.scrollY / scrollable < REVEAL_AT);
    }

    function onRevealScroll() {
      if (revealTicking) return;
      revealTicking = true;
      window.requestAnimationFrame(checkReveal);
    }

    window.addEventListener('scroll', onRevealScroll, { passive: true });
    window.addEventListener('resize', onRevealScroll, { passive: true });
    checkReveal();   // arriving already scrolled (reload, back button)
    if (!pageLoaded) {
      window.addEventListener('load', function () { pageLoaded = true; checkReveal(); });
    }

    function stepEl(id) {
      return panel.querySelector('.help-step[data-step="' + id + '"]');
    }

    function showStep(id) {
      steps.forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.step === id);
      });
      var el = stepEl(id);
      if (el && titleEl) titleEl.textContent = el.dataset.title || '';
      current = id;
      backBtn.hidden = history.length === 0;
      if (body) body.scrollTop = 0;
    }

    function goTo(id, issue) {
      history.push(current);
      if (id === 'form' && issueInput) {
        issueInput.value = issue || '';
        if (formNote) {
          if (issue) {
            formNote.textContent = 'Regarding: ' + issue;
            formNote.hidden = false;
          } else {
            formNote.hidden = true;
          }
        }
      }
      showStep(id);
    }

    function back() {
      var prev = history.pop() || 'root';
      showStep(prev);
    }

    function open() {
      // Anything that opens the widget directly (footer Contact Us, the
      // reload after a form submit) shows it regardless of scroll depth.
      setScrollHidden(false);
      widget.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      fab.setAttribute('aria-expanded', 'true');
    }

    function close() {
      widget.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      fab.setAttribute('aria-expanded', 'false');
      history = [];
      showStep('root');
      checkReveal();   // back under the 60% rule once closed
    }

    fab.addEventListener('click', function () {
      widget.classList.contains('is-open') ? close() : open();
    });
    closeBtn.addEventListener('click', close);
    backBtn.addEventListener('click', back);

    // Footer "Contact Us" (any [data-open-contact]) opens the widget straight at the contact channels.
    document.querySelectorAll('[data-open-contact]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        history = [];
        open();
        history.push('root');
        showStep('channels');
      });
    });

    // Option buttons navigate the tree; channel links (<a>, no data-goto) pass through.
    panel.addEventListener('click', function (e) {
      var opt = e.target.closest('.help-opt[data-goto]');
      if (!opt) return;
      e.preventDefault();
      goTo(opt.dataset.goto, opt.dataset.issue);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && widget.classList.contains('is-open')) close();
    });

    // Click outside the widget closes it.
    document.addEventListener('click', function (e) {
      if (widget.classList.contains('is-open') && !widget.contains(e.target)) close();
    });

    // On submit: subscribe the user to Klaviyo (fires their auto-email flow),
    // then let the Shopify contact form submit to email the team.
    var form = document.getElementById('helpContactForm');
    var cfg = window.BrumeConfig || {};

    // The WhatsApp checkbox carries no name; a hidden field always posts Yes/No so
    // the team email records the choice even when the box is left unticked
    // (an unchecked checkbox submits nothing at all).
    var waCheck = document.getElementById('helpWhatsApp');
    var waField = document.getElementById('helpWhatsAppField');
    if (form && waCheck && waField) {
      form.addEventListener('submit', function () {
        waField.value = waCheck.checked ? 'Yes' : 'No';
      });
    }

    if (form && cfg.klaviyoCompanyId && cfg.klaviyoListId) {
      form.addEventListener('submit', function (e) {
        if (form.dataset.kvSent) return;          // our programmatic resubmit — let it through
        if (!form.checkValidity()) return;        // let the browser flag required fields first

        e.preventDefault();

        var get = function (sel) { var el = form.querySelector(sel); return el ? el.value.trim() : ''; };

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Help widget',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: get('input[name="contact[email]"]'),
                    first_name: get('input[name="contact[name]"]'),
                    properties: {
                      Issue: get('input[name="contact[Issue]"]'),
                      Message: get('textarea[name="contact[body]"]'),
                      Phone: get('input[name="contact[phone]"]'),
                      'Contact by WhatsApp': (waCheck && waCheck.checked) ? 'Yes' : 'No'
                    },
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: cfg.klaviyoListId } } }
          }
        };

        var submitTeamEmail = function () {
          if (form.dataset.kvSent) return;
          form.dataset.kvSent = '1';
          form.submit();                          // Shopify processes → emails the team, reloads
        };
        var fallback = setTimeout(submitTeamEmail, 1500);

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyoCompanyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
          body: JSON.stringify(payload),
          keepalive: true,
          mode: 'cors'
        }).catch(function () {}).finally(function () {
          clearTimeout(fallback);
          submitTeamEmail();
        });
      });
    }

    // After a successful form submit the page reloads — re-open to the success state.
    // The empty form sits right below the confirmation, so visitors can submit again.
    if (panel.querySelector('[data-hw-posted]')) {
      history.push('root');
      open();
      showStep('form');
    }
  }

  window.Brume.initHelpWidget = initHelpWidget;

  if (document.readyState !== 'loading') initHelpWidget();
  else document.addEventListener('DOMContentLoaded', initHelpWidget);
})();
